<div fxLayout="column" fxLayoutAlign="center center" style="margin-top:120px; padding-left:15px; padding-right: 15px;">
<mat-tab-group>
  <mat-tab label="Διαχείριση συναινέσεων GDPR"> Στο πλαίσιο της συμμόρφωσης του οργανισμού μας με τον Ευρωπαϊκό Γενικό Κανονισμό Προστασίας Δεδομένων (GDPR), μπορείτε να διαχειρίζεστε τις συναινέσεις σας εύκολα, νόμιμα και με ασφάλεια.
  </mat-tab>
  <mat-tab label="Ηλεκτρονικές Δηλώσεις"> Πραγματοποιήστε ηλεκτρονικά τις δηλώσεις σας στα διάφορα προγράμματα του οργανισμού.
    Θέλω να μάθω περισσότερα </mat-tab>
  <mat-tab label="Online πληρωμές με χρεωστική/πιστωτική κάρτα"> Πληρώστε online και με ασφάλεια, διάφορα ποσά για συμμετοχή σε δραστηριότητες. </mat-tab>
  <mat-tab label="Αλλαγή δρομολογίου"> Συμπληρώστε την ηλεκτρονική αίτηση για τις έκτακτες αλλαγές δρομολογίου. </mat-tab>
</mat-tab-group>
</div>
